import React from 'react';
import * as styles from './preloader.module.sass';

export const BigPreloader = () => {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="200" height="200" className={styles.load_conainer}>
      <linearGradient
        id="a"
        gradientUnits="userSpaceOnUse"
        x1="6.35"
        y1="264.95"
        x2="40.35"
        y2="264.95"
        gradientTransform="matrix(2.2222 0 0 -2.2222 52.556 667.667)"
      >
        <stop offset="0" stopColor="#09b1e7" />
        <stop offset="1" stopColor="#29f499" />
      </linearGradient>
      <path
        className={styles.preloader_logo}
        fill="url(#a)"
        d="M72.6 96.8c.1 0 .1 0 0 0l.2-.1 10-22.9c.1-.1.2-.3.3-.3.1-.1.3-.1.4-.1.2 0 .3 0 .4.1l.3.3 14.5 28.4.1.1h.2l.1-.1 8.1-15.9c.1-.1.1-.2.2-.3.1-.1.2-.1.3-.1.1 0 .2 0 .3.1.1.1.2.1.3.2l7.1 10.5.1.1H142.4c-.6-1.8-1.9-3.3-3.5-4.2l-64-36.3c-.8-.5-1.7-.7-2.7-.7-.9 0-1.9.2-2.7.7-.8.5-1.5 1.1-2 1.9-.5.8-.7 1.7-.7 2.6v36h5.8z"
      />
      <linearGradient
        id="b"
        gradientUnits="userSpaceOnUse"
        x1="-10.86"
        y1="227.157"
        x2="38.14"
        y2="267.157"
        gradientTransform="matrix(2.2222 0 0 -2.2222 52.556 667.667)"
      >
        <stop offset=".297" stopColor="#09b1e7" />
        <stop offset="1" stopColor="#32d29f" />
      </linearGradient>
      <path
        className={styles.preloader_logo}
        fill="url(#b)"
        d="M112.7 102c-.1 0-.2 0-.3-.1s-.2-.1-.2-.2l-4.2-6.3-8.9 18c-.1.1-.1.2-.2.3-.1.1-.2.1-.4.1s-.2 0-.4-.1c-.1-.1-.2-.2-.2-.3L83.7 84.6l-.1-.1h-.2l-.1.1-7.2 17c-.1.1-.1.2-.2.3-.1.1-.2.1-.4.1h-8.7v37c0 .9.2 1.9.7 2.7.5.8 1.1 1.5 2 2 .8.5 1.7.7 2.7.7.9 0 1.9-.2 2.7-.7l64-37.4c1.7-1 2.9-2.5 3.5-4.3h-29.7z"
      />
      <path
        className={styles.ecgline}
        fill="none"
        stroke="#000"
        strokeMiterlimit="10"
        d="M180.3 99.4h-66.6l-5.9-8.3-9.3 16.3-15.2-28.3-9.1 20.3H7.6"
      />
    </svg>
  );
};
